<template>
	<div class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="title">{{$t('pages.car.breadcrumb')}}</div>
			<div class="card">
					<div class="cardTitle">
						<div class="cardTitleLeft">
							<div class="cardTitleLine"></div>{{$t('pages.car.cart_title')}}
						</div>
						<div class="searchArea">
							<input type="text" :placeholder="$t('pages.car.search_placeholder')" class="searchInput" v-model="keywords"/>
							<div class="searchBtn">{{$t('pages.car.search_btn')}}</div>
						</div>
					</div>
				<table>
					<thead>
						<th  class="checkBoxArea"></th>
						<th>{{$t('pages.car.th_select')}}</th>
						<th>{{$t('pages.car.th_item_info')}}</th>
						<th>{{$t('pages.car.th_spec_param')}}</th>
						<th>{{$t('pages.car.th_unit_price')}}</th>
						<th>{{$t('pages.car.th_quantity')}}</th>
						<th>{{$t('pages.car.th_subtotal')}}</th>
						<th>{{$t('pages.car.th_actions')}}</th>
					</thead>
					<tbody>
						<tr v-for="(item, index) in shopCartList" :key="item.id">
							<td class="checkBoxArea">
								<div class="tdInner">
									<input type="checkbox" v-model="select" :value="item"   />
								</div>
							</td>
							<td>
								<div class="tdInner">{{index+1}}</div>
							</td>
							<td>
								<div class="tdInner tdFlex">
									<img  :src="item.sku_image"/>
									<div class="infoDetail">
										<div>{{item.product_name}}</div>
										<div class="grayText">{{item.cate_name}}</div>
									</div>
								</div>
							</td>
							<td>
								<div class="tdInner parameterInfo"><p>{{item.sku_text}}</p></div>
							</td>
							<td>
								<div class="tdInner">
									<div class="redText">￥{{item.sku_price+item.sku_tax}}{{$t('pages.car.incl_tax')}}</div>
									<div class="grayText">￥{{item.sku_price}} {{$t('pages.car.excl_tax')}}</div>
								</div>
							</td>
							<td>
								<div class="tdInner">
									<Counter @messageSent="handleMessage" :type="type" :val="item.number" :id="item.id"></Counter>
								</div>
							</td>
							<td>
								<div class="tdInner">
									<div class="redText">￥{{item.total_price+item.total_tax}} {{$t('pages.car.incl_tax')}}</div>
									<div class="grayText">￥{{item.total_price}} {{$t('pages.car.excl_tax')}}</div>
								</div>
							</td>
							<td>
								<div class="tdInner tdFlex">
									<div class="saveBtn" @click="addCollect(item.id)">{{$t('pages.car.collect')}}</div>
									<div class="delBtn" @click="DelCal(item.id)">{{$t('pages.car.delete')}}</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="paginationArea">
					<PaginationVue  :items="shopCartList" :pageSize="10"></PaginationVue>
				</div>
			</div>

			<div class="card">
					<div class="cardInner">
						<div class="allSelect">
							<div class="allSelectCheckbox"><input type="checkbox" @click="checkAll" v-model="flag" />{{$t('pages.car.select_all')}}</div>
							<div  @click="DeleteSelect()">{{$t('pages.car.delete_selected')}}</div>
						</div>
						<div class="total">{{$t('pages.car.total_summary',{count: TotalCount, amount: TotalAmount})}}<div class="payBtn" @click="GoToPay()">{{$t('pages.car.pay_btn')}}</div></div>
				</div>

			</div>

		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import Counter from '../components/counter.vue'
	import PaginationVue from '../components/pagination.vue';
	export default{
		components:{
			Head2,
			Foot2,
			Counter,
			PaginationVue
		},
		data(){
			return {
				type: 'SMALL',
				shopCartList:[],
				cartId:0,
				flag: false, // 开关
	            select: [], // 用来存储数据的id
				TotalCount:0,
				TotalAmount:0,
				idstr:"",
				parameter:[],//用来存储参数到下个页面
				keywords:""
			}
		},
		created() {
			this.getShoppingCartInfo();
		},
		methods: {
			getShoppingCartInfo() {
				this.shopCartList=[];
				this.$scUtil.axiosPost(this, 'ShoppingCartApi/GetCartList', {
					userName: localStorage.getItem('username'),
					keywords:this.keywords
				}, res => {
					if (res.code == 100) {
						this.shopCartList = res.data;
						//console.log(JSON.stringify(this.shopCartList));
					}

				});
			},
			handleMessage(message) {

				this.qty = message.number;
				this.cartId=message.id;
				//console.log(message.productId);
				if(this.qty>0)
				{
					if(this.shopCartList.find(item=>item.id==this.cartId).number!=this.qty)
					{
						try {
							this.$scUtil.axiosPut(this, 'ShoppingCartApi/Update', {
								cartId: this.cartId,
								number:this.qty
							}, res => {
								//console.log(res.code);
								if (res.code == 100) {
									this.$message({
										message: res.message,
										type: "success"
									});
									this.getShoppingCartInfo();
									return;
								}

							});
						} catch (error) {
							//console.log(error);
						}
					}
				}
				else
				{
										this.$confirm(this.$t('pages.car.confirm_delete_message'), this.$t('pages.car.confirm_title'), {
												distinguishCancelAndClose: true,
												confirmButtonText: this.$t('pages.car.confirm_confirm'),
												cancelButtonText: this.$t('pages.car.confirm_cancel'),
												type: 'warning'
											}).then(() => {
					         try {
					         	this.$scUtil.axiosPut(this, 'ShoppingCartApi/Delete', {
					         		cartIds: this.cartId+",",
					         	}, res => {
					         		//console.log(res.code);
					         		if (res.code == 100) {
					         			this.$message({
					         				message: res.message,
					         				type: "success"
					         			});
					         			this.getShoppingCartInfo();
					         			return;
					         		}

					         	});
					         } catch (error) {
					         	//console.log(error);
					         }
					      }).catch(action => {
					        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
							//console.log(action)
					        if (action == 'cancel'||cation=='close') {
								//console.log("执行了吗")
					          this.getShoppingCartInfo();
					        }
					})
				}
			},
			checkAll(){
				if (this.flag) { // flag是false进入条件
					this.select = [] // 为空说明没有被选中
				}else{
					this.shopCartList.forEach(item => { //遍历arr
						this.select.push(item) // 给select添加id，有了id值说明都被选中
					});
				}
			},
			CalMoney(){
				this.TotalAmount=0;
				this.TotalCount=0;
				this.select.forEach(item =>
				{
					//console.log(item)
					this.TotalCount+=item.number;
					this.TotalAmount+=item.total_price+item.total_tax;
				});
			},
			DelCal(id){
					this.$confirm(this.$t('pages.car.confirm_delete_message'), this.$t('pages.car.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('pages.car.confirm_confirm'),
					        cancelButtonText: this.$t('pages.car.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try {
				         	this.$scUtil.axiosPut(this, 'ShoppingCartApi/Delete', {
				         		cartIds: id+",",
				         	}, res => {
				         		//console.log(res.code);
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
				         			this.getShoppingCartInfo();
				         			return;
				         		}

				         	});
				         } catch (error) {
				         	//console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						//console.log(action)
				        if (action == 'cancel'||cation=='close') {
							//console.log("执行了吗")
				          this.getShoppingCartInfo();
				        }
				})
			},
			addCollect(id){
				this.$scUtil.axiosPut(this, 'CollectApi/Add', {
					productId: id,
					userName: localStorage.getItem('username'),
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						//this.getProductInfo();
						return;
					}

				});
			},
			DeleteSelect(){
				this.select.forEach(item => {
				    this.idstr+=item.id+","
				});
					this.$confirm(this.$t('pages.car.confirm_delete_message'), this.$t('pages.car.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('pages.car.confirm_confirm'),
					        cancelButtonText: this.$t('pages.car.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try
						 {
				         	this.$scUtil.axiosPut(this, 'ShoppingCartApi/Delete', {
				         		cartIds: this.idstr,
				         	}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getShoppingCartInfo();
				         			//console.log("为什么删除了不刷新数据");
									//console.log(JSON.stringify(this.shopCartList));
				         			return;
				         		}

				         	});
				         } catch (error) {
				         	//console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						//console.log(action)
				        if (action == 'cancel'||cation=='close') {
							//console.log("执行了吗")
				          this.getShoppingCartInfo();
				        }
				})
			},GoToPay(){
				this.parameter=[];
				//如果为空，则提示选择产品
				if(this.select.length==0){

						this.$message({message: this.$t('pages.car.select_products_warning'),type: "warning"});
					return;
				}
				//构造传递参数
				this.select.forEach(item => {
				    this.parameter.push({skuId:item.sku_id,number:item.number});
				});
				localStorage.setItem('payList',JSON.stringify(this.parameter));
				this.select.forEach(item => {
				    this.idstr+=item.id+","
				});
				localStorage.setItem('cartIds',this.idstr);
				this.$router.push({name:'ConfirmOrderVue'})

			}

		},
		watch: {
			select() { // 监听select
				if (this.select.length == this.shopCartList.length) { //select的长度 == arr的长度，说明4个都被选中
					this.flag = true //那么全选就为选中
				} else {
					this.flag = false // 否则全选就为没选中
				}
				this.CalMoney();
			}
		}
	}
</script>

<style scoped>
	.pageArea{
		background-color: #ebecee;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.mainAea{
		width: 1200px;
	}

	.title{
		font-size: 13px;
		color: #333333;
		height: 37px;
		line-height: 37px;
	}

	.card{
		width: 1200px;
		background-color: #fff;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 20px;
	}

	.cardTitle{
		height: 58px;
		line-height: 58px;
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
	}

	.cardTitleLeft{
		font-size: 18px;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.cardTitleLine{
		width: 5px;
		height: 17px;
		background-color: #0380fe;
		margin-right: 11px;
	}

	.searchArea{
		width:399px;
		height:28px;
		border:1px solid #0380fe;
		display:flex;
		align-items: center;
	}

	.searchBtn{
		width: 82px;
		background-color: #0380fe;
		color: #ffffff;
		font-size: 13px;
		height:28px;
		line-height:28px;
		text-align: center;
		cursor: pointer;
	}

	.searchInput{
		padding-left: 15px;
		font-size: 12px;
		flex: 1;
		height:28px;
		border: none;
	}

	.searchInput:focus{
		outline: none;
	}

	.searchInput::placeholder{
	  color: #888888;
	}

	table{
		border-collapse: collapse;
		width: 100%;
	}

	table thead{
		height: 45px;
		background-color: #ebf5ff;
		font-size: 14px;
		color: #000;
	}


	.infoDetail{
		width: 128px;
		word-break: break-all;

	}

	.tdFlex img{
		width: 79px;
		height: 79px;
		border: 1px solid #e7e7e7;
		margin-right: 15px;
	}

	table tr td{
		color: #000;
		font-size: 13px;
		min-width:60px;
		padding: 20px 0;
	}

	table tr td.checkBoxArea{
		min-width: 30px;
	}

    table tr{
		border-bottom: 1px solid #e2e2e2;
	}


	table tr td .grayText{
		font-size: 13px;
		color: #888888;
	}

	table tr td .redText{
		color: #db050f;
	}

	.tdInner{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		color: #000000;
		margin: 0 auto;
		line-height: 25px;
	}

	.parameterInfo{
		font-size: 13px;
		color: #000000;
		width: 193px;
		word-break: break-all;
		text-align: left;
		align-items: flex-start;
	}

	.parameterInfo p{
		text-align: left;
	}

	.tdFlex{
		display: flex;
		flex-direction: row;
	}

	.saveBtn{
		color: #0380fe;
		margin-right: 20px;
		cursor: pointer;
	}

	.delBtn{
		color: #888888;
		cursor: pointer;
	}

	.cardInner{
		width: 100%;
		display:flex;
		justify-content: space-between;
		height: 70px;
		align-items: center;
	}

	.allSelect{
		font-size: 13px;
		color: #000;
		display: flex;
		align-items: center;
	}

	.allSelectCheckbox{
		margin-right: 20px;
		display: flex;
		align-items: center;
	}

	.allSelectCheckbox input{
		margin-right: 5px;
	}

	.total{
		font-size: 13px;
		color: #333333;
		display: flex;
		align-items: center;
	}

	.totalRed1{
			font-size: 15px;
			color: #db050f;
	}

	.totalRed1:nth-child(1){
		margin: 0 5px;
	}


	.totalRed2{
		font-size: 16px;
		color: #db050f;
	}

	.payBtn{
		width: 171px;
		height: 39px;
		background: #0380fe;
		border-radius: 5px;
		line-height: 39px;
		text-align: center;
		color: #fff;
		font-size: 15px;
		font-weight: bolder;
		margin-left: 35px;
	}


	.paginationArea{
		width: 100%;
		padding: 30px 0;
		display: flex;
		justify-content: center;
	}

	tr:hover,
	tr:active{
		background: #f3f9fe;
		cursor: pointer;
	}
</style>